'use client'

import { Cell, Divider, Image, Label } from '@vinted/web-ui'
import { useContext } from 'react'

import { GetShippingLabelContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { EMPTY_USER_IMAGE_NAME, useAsset } from '@marketplace-web/shared/assets'

import { truncateString } from '../../../../utils/string'

const MAX_CHARACTERS = 38

const BuyerAddress = () => {
  const translate = useTranslate('conversation.get_shipping_label.modal')
  const {
    state: {
      labelOptions: { labelOptions, labelOptionsRewrite },
    },
  } = useContext(GetShippingLabelContext)

  const asset = useAsset('assets/no-photo')

  const labelOptionsData = labelOptionsRewrite || labelOptions

  if (!labelOptionsData) return null

  return (
    <>
      <Label type={Label.Type.Stacked} text={translate('buyers_address_label')} />
      <Cell
        prefix={
          <Image
            src={labelOptionsData.receiver.photoUrl}
            size={Image.Size.Regular}
            styling={Image.Styling.Circle}
            fallbackSrc={asset(EMPTY_USER_IMAGE_NAME)}
          />
        }
        title={truncateString(labelOptionsData.receiver.name, MAX_CHARACTERS)}
        body={translate('buyers_address_body')}
      />
      <Divider />
    </>
  )
}

export default BuyerAddress
